<template>
  <div class="counter flex w-fit space-x-2 rounded-xl p-2 font-semibold">
    <button
      type="button"
      :class="
        isMinDisabled ? 'text-situational-grey' : 'text-text-neutral-primary'
      "
      data-qa-id="counter.decrease"
      @click="handleDecrease"
    >
      <!-- prettier-ignore -->
      <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 13H6v-2h12v2Z" fill="currentColor"/></svg>
    </button>
    <p class="text-text-neutral-primary min-w-[25px] text-center font-medium">
      {{ counter }}
    </p>
    <button
      type="button"
      :class="
        isMaxDisabled ? 'text-situational-grey' : 'text-text-neutral-primary'
      "
      data-qa-id="counter.increase"
      @click="handleIncrease"
    >
      <!-- prettier-ignore -->
      <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 13v5h2v-5h5v-2h-5V6h-2v5H6v2h5Z" fill="currentColor"/></svg>
    </button>
  </div>
</template>

<script setup lang="ts">
  const props = defineProps<{
    isMaxDisabled: boolean;
    isMinDisabled: boolean;
    counter: number;
  }>();

  const emit = defineEmits<{
    onChange: [amount: number];
    onDisabledClick: [type: string];
  }>();

  const handleIncrease = () => {
    if (props.isMaxDisabled) {
      emit('onDisabledClick', 'max');
    } else {
      emit('onChange', props.counter + 1);
    }
  };

  const handleDecrease = () => {
    if (props.isMinDisabled) {
      emit('onDisabledClick', 'min');
    } else {
      emit('onChange', props.counter - 1);
    }
  };
</script>

<style scoped>
  .counter {
    background-color: var(--counter-bg, rgb(var(--background-neutral-primary)));
  }
</style>
